// extracted by mini-css-extract-plugin
export default {"languageList":"CommercialLanguageList_languageList__XEVOf"};